export interface IUserIdResponse {
    data: {
        success: boolean;
        results: number;
    }
}